import SiteWidePromoBanner from './SiteWidePromoBanner';

export * from './types';
export default SiteWidePromoBanner;
